export enum AuthorityService {
  MOBILE_ID = 'ras',
  DEEP_ID = 'did',
  YAPEAL_ID = 'yid',
  SIGN8 = 'sign8'
}
